import productInstance from '../product/instance'

const getOwnMenuCardCopyTasks = () => {
	return productInstance.get('/menuCardCopyTasks')
}

export default getOwnMenuCardCopyTasks
